"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = initialize;
function initialize() {
    var closeButtons = document.querySelectorAll(".notification .notification__close");
    if (closeButtons) {
        closeButtons.forEach(function (closeButton) {
            closeButton.addEventListener("click", function () {
                this.parentElement.classList.remove("vissible");
            });
        });
    }
}